
import Footer from "./Footer";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import Breadcrumb, { buildItemsFromPath } from "../Breadcrumb";

const Layout = ({
    children,
    showBreadcrumb = true,
    pageTitle = "",
    breadcrumbLabel = "",
    breadcrumbItems = [],
}) => {
    const location = useLocation();
    const derivedItems =
        Array.isArray(breadcrumbItems) && breadcrumbItems.length > 0
            ? breadcrumbItems
            : buildItemsFromPath(location.pathname, breadcrumbLabel || pageTitle);
    const resolvedTitle =
        pageTitle || derivedItems[derivedItems.length - 1]?.label || "";
    const shouldShowBanner =
        showBreadcrumb && location.pathname !== "/" && resolvedTitle;

    return (
        <div>
            <Header/>
            {shouldShowBanner && (
                <section className="contact-banner-sec">
                    <div className="container-fluid">
                        <div className="page-header">
                            <h1>{resolvedTitle}</h1>
                        </div>
                        <Breadcrumb
                            items={derivedItems}
                            currentLabel={breadcrumbLabel || resolvedTitle}
                        />
                    </div>
                </section>
            )}
            {children}
            <Footer />
        </div>
    )
}

export default Layout;
